import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { AdminAuditoriaPage } from "@/features/admin-auditoria/components/AdminAuditoriaPage";

/**
 * Ruta `/admin/auditoria` · acceso Auditor y Administrador (decisión 29).
 * Sin loader (las queries dependen de state local).
 */
export const Route = createFileRoute("/_authed-tw/admin/auditoria")({
  component: () => (
    <PermissionGate permisos={[PERMISOS.auditoriaVer]}>
      <AdminAuditoriaPage />
    </PermissionGate>
  ),
});
